import { LoadingIndicator } from '@anchor/react-components/dist/lib/components'
import React from 'react'

function Loading() {
  return (
    <div
    style={{
      width: "100%",
      height: "90vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <LoadingIndicator
      appearance="default"
      fit="large"
      id="testing"
      label="Loading Data, Please Wait..."
      variant="spinner"
      style={{background:"none"}}
    />
  </div>
  )
}

export default Loading